const ceps = {

  getAddress(cep, params) {
    return fetch(
      `${process.env.REACT_APP_API_CEPS}${cep}`,
      params
    )
  }
}

export default ceps
